'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlIp = require('./validateUrlIp');

var _validateUrlIp2 = _interopRequireDefault(_validateUrlIp);

var _validateUrlUnicodeDomain = require('./validateUrlUnicodeDomain');

var _validateUrlUnicodeDomain2 = _interopRequireDefault(_validateUrlUnicodeDomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateUrlUnicodeHost = (0, _regexSupplant2.default)('(?:' + '#{validateUrlIp}|' + '#{validateUrlUnicodeDomain}' + ')', { validateUrlIp: _validateUrlIp2.default, validateUrlUnicodeDomain: _validateUrlUnicodeDomain2.default }, 'i'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validateUrlUnicodeHost;
module.exports = exports['default'];